import React from 'react';
import t from 'react-translate';
import { config as pendoConfig } from '@config/pendo.config.json';

import NoAdmins from 'institutions/components/course-clone-modal/step-two/no-admins';
import AdminSelectionList from './admin-selection-list';

import { useCloneMentorshipProgram } from '../state/context';
import { CloneMentorshipProgramActionType } from '../state/types';

const CloneMentorshipProgramStepTwo = () => {
  const { state, dispatch } = useCloneMentorshipProgram();
  const dataQATag = pendoConfig.pendo.athena.mentorshipProgram.cloneProgramModal;

  const handleToggleItem = (adminId: number, currentlySelected: boolean) => {
    dispatch({
      type: CloneMentorshipProgramActionType.TOGGLE_ADMIN,
      payload: { adminId: String(adminId), selected: !currentlySelected },
    });
  };

  const handleToggleAll = (checked: boolean) => {
    dispatch({
      type: CloneMentorshipProgramActionType.TOGGLE_ALL_ADMINS,
      payload: { selected: checked },
    });
  };

  const renderContent = () => {
    if (state.isFetchingAdmins) {
      return (
        <div className='empty-state p-4 text-align-center gray-2' data-qa='clone-mentorship-admins-loading'>
          {t.MENTORING_PROGRAMS.PROGRAM_HEADER_MENU.CLONE.STEPS.STEP_TWO.LOADING()}
        </div>
      );
    }

    if (state.admins.length === 0) {
      return <NoAdmins />;
    }

    return (
      <AdminSelectionList
        items={state.admins}
        selectedItems={state.selectedAdmins}
        onToggleItem={handleToggleItem}
        onToggleAll={handleToggleAll}
        labels={{
          selectAll: t.MENTORING_PROGRAMS.PROGRAM_HEADER_MENU.CLONE.STEPS.STEP_TWO.SELECT_ALL(),
          unselectAll: t.MENTORING_PROGRAMS.PROGRAM_HEADER_MENU.CLONE.STEPS.STEP_TWO.UNSELECT_ALL(),
          counter: (selected, total) => t.MENTORING_PROGRAMS.PROGRAM_HEADER_MENU.CLONE.STEPS.STEP_TWO.COUNTER(
            String(selected),
            String(total),
          ),
        }}
        dataQa={{
          selectAll: dataQATag.selectAll,
          itemCheckbox: dataQATag.adminCheckbox,
        }}
      />
    );
  };

  return (
    <div className='clone-mentorship-step-two h-100 d-flex flex-column'>
      {renderContent()}
    </div>
  );
};

export default CloneMentorshipProgramStepTwo;
